import { FRANCHISE_URL_RESOURCE } from '../api/resources';
import { createResourceSlice } from '../store/resource/createResourceSlice';

const franchiseUrlsSlice = createResourceSlice({
    resource: FRANCHISE_URL_RESOURCE,
    byKey: ['locationId'],
});

export const {
    indexFulfilled,
    showFulfilled,
    storeFulfilled,
    updateFulfilled,
    destroyFulfilled,

    indexFranchiseUrls,
    showFranchiseUrl,
    storeFranchiseUrl,
    updateFranchiseUrl,
    archiveFranchiseUrl,
    restoreFranchiseUrl,
    destroyFranchiseUrl,
} = franchiseUrlsSlice.actions;

export const {
    selectFranchiseUrlById,
    makeFranchiseUrlsByIdsSelector,
    selectAllFranchiseUrlIds,
    selectAllFranchiseUrls,
    selectFranchiseUrlsLoading,
    selectFranchiseUrlsInitialized,
    selectFranchiseUrlLoading,
    selectFranchiseUrlInitialized,
    selectFranchiseUrlIdsByFranchiseId,
    makeFranchiseUrlByFranchiseIdSelector,
    selectFranchiseUrlLoadingByFranchiseId,
    selectFranchiseUrlInitializedByFranchiseId,
    selectFranchiseUrlByFranchiseIdAndAgencyId,
} = franchiseUrlsSlice.selectors;

export const { useFranchiseUrls, useFranchiseUrl, useFranchiseUrlsByFranchiseId} = franchiseUrlsSlice.hooks;

export default franchiseUrlsSlice.reducer;
